<template>
    <div class="flex  flex-wrap lg:justify-start justify-center  items-center gap-2  lg:gap-10 px-10 py-2">
        <img src="/teh/bakanlikk.svg" class="h-14"></img>
        <a href="https://www.turkiyeeticarethaftasi.com"><img src="/teh/logo.jpg"></img></a>

    </div>



    <div class="w-full flex h-[270px] my-2 bg-cover bg-center backdrop-blur-xl bg-no-repeat relative"
        style="background-image: url('/teh/Banner_Oduller.jpg');">


        <div class="w-full h-full  flex flex-col justify-center items-center">

            <h1 class="text-2xl lg:text-4xl font-bold text-white  text-center px-4">
                <span style="text-shadow:2px 2px 4px rgba(0, 0, 0, 0.5)" v-html="title"></span>
            </h1>
        </div>

    </div>
</template>

<script setup>

const props = defineProps({
    title: {
        type: String,
        required: true
    }
});
</script>
